module.exports = __webpack_public_path__ + "static/media/thaitvonline2.b9465a95.png";